import { isEmpty } from 'lodash';
/**
 * 获取素材资源对象
 * @param payload
 * @param initMaterial
 * @returns
 */
export const getMaterial = (
  payload: Record<string, string>,
  initMaterial?: Record<string, string>,
) => {
  const { key, url } = payload;
  const materialMap = { ...initMaterial };
  if (!materialMap?.[key]) {
    materialMap[key] = url;
  }
  return materialMap;
};

/**
 * 过滤素材对象
 * @param postData
 * @param materialMap
 * @returns
 */
export const postMaterial = (
  postData: Record<string, any>,
  materialMap: Record<string, string>,
) => {
  if (isEmpty(materialMap)) return {};
  const dataStr = JSON.stringify(postData);
  const material: Record<string, string> = {};
  Object.keys(materialMap)
    .filter(key => key && dataStr.indexOf(key) !== -1)
    .forEach((key) => {
      material[key] = materialMap[key];
    });
  return material;
};
